import FAQBase from "./FAQBase"

const FAQs = () => {
  return <FAQBase title="All FAQs" showTypeSelector={true} />
}

export default FAQs
